<aside class="h-full w-70 overflow-x-hidden">
	<div class="p-4">
		<div class="flex flex-col items-center justify-center">
			<div class="relative mb-3 group">
				<div
					[routerLink]="['/ads/profile']"
					class="rounded-full bg-gradient-to-br from-primary-300 to-primary-500 p-1 group-hover:shadow-xl cursor-pointer">
					<div class="overflow-hidden rounded-full shadow-sm">
					@if (profileImageFileId() | fileLink; as avatarUrl) {
						<img
							[src]="avatarUrl"
							alt="avatar"
							class="h-24 w-24 rounded-full  object-cover border border-gray-300"
						/>
					} @else {
						<div class="flex h-24 w-24 items-center justify-center rounded-full border border-gray-300">
							<i class="pi pi-user text-4xl"></i>
						</div>
					}
					</div>
				</div>
			</div>
			@if (
				user.getUser()().userType === AppUserGetAccountRecUserTypeEnum.Legal &&
				user.getUser()().legalAccountStatus === AppUserGetAccountRecLegalAccountStatusEnum.Approved
			) {
				<div class="font-extrabold">{{ user.getUser()().companyName }}</div>
				<div class="font-extralight">({{ user.getUser()().firstName + ' ' + user.getUser()().lastName }})</div>
			} @else {
				<div class="font-extrabold">{{ user.getUser()().firstName + ' ' + user.getUser()().lastName }}</div>
			}
			@if (user.getUser()().shahkarVerified) {
				<div class="mt-2 flex items-center gap-1 text-green-700 text-xs font-medium bg-green-50 px-3 py-1.5 rounded-full">
					<i class="pi pi-check-circle text-green-500"></i>
					<span>احراز هویت (شاهکار) تایید شده است</span>
				</div>
			}@else {
				<div class="mt-2 flex items-center gap-1 text-white text-xs font-medium bg-gray-300 px-3 py-1.5 rounded-full">
					<i class="pi pi-check-circle text-green-500"></i>
					<span>برای فعال سازی کامل امکانات، احراز هویت خود را تکمیل کنید.</span>
				</div>
}

			@if (roles && roles.length >= 2) {
				<div class="mt-3">
					<p-select [options]="roles" [ngModel]="selectedRole()" (onChange)="changeRole($event)">
						<ng-template let-option pTemplate="selectedItem">
							<span>
								{{ 'roles.' + option | translate }}
							</span>
						</ng-template>

						<ng-template let-option pTemplate="item">
							<span>
								{{ 'roles.' + option | translate }}
							</span>
						</ng-template>
					</p-select>
				</div>
			} @else if (roles && roles.length === 1) {
				<div class="mt-3 text-xs font-medium text-primary bg-primary/10 px-3 py-1.5 rounded-full">
					{{ 'roles.' + roles[0] | translate }}
				</div>
			}
		</div>
	</div>

	<p-panelmenu [model]="items()" class="w-full md:w-70">
		<ng-template #item let-item>
			<a
        [routerLinkActiveOptions]="item.routerLinkActiveOptions"
        [routerLink]="item.items?.length ? null : [item.router]"
        [routerLinkActive]="item.items?.length ? '' : 'active-highlight'"
        pRipple
				class="flex cursor-pointer items-center px-4 py-2 group gap-2">
				<i
					[class.pi-chevron-down]="item.items.length && item.expanded"
					[class.pi-chevron-right]="item.items.length && !item.expanded && langService.currentLanguage() === 'en'"
					[class.pi-chevron-left]="item.items.length && !item.expanded && langService.currentLanguage() === 'fa'"
					[class]="' pi pi-' + item.icon + ' text-primary group-hover:text-inherit'"></i>
				<span class="">
					{{ item.label | translate }}
					@if (item.badgeCount) {
						<p-badge [value]="item.badgeCount" severity="danger" badgeSize="small" />
					}
				</span>
			</a>
		</ng-template>
	</p-panelmenu>
</aside>
